// import React, { useEffect, useState } from "react";
// import { useNavigate } from 'react-router-dom';
// import './Profile.css'; // Assuming you have a Profile.css for styling

// const Profile = () => {
//     const navigate = useNavigate();
//     const [userData, setUserData] = useState(null);

//     useEffect(() => {
//         const data = sessionStorage.getItem('userData');
//         if (data) {
//             setUserData(JSON.parse(data)); // Parse the stored JSON string
//         }
//     }, []);

//     const handleLogout = () => {
//         sessionStorage.removeItem('userId');
//         sessionStorage.removeItem('userData');
//         sessionStorage.removeItem('authToken');
//         sessionStorage.removeItem('userDistrict');
//         navigate('/');
//     };

//     return (
//         <>
//             <div className="sidebar-nav">
//                 <h2>Menu</h2>
//                 <ul>
// <li><button className="side-button" onClick={() => window.location.href = '/Dashboard'}>Posts</button></li>
// <li><button className="side-button" onClick={() => window.location.href = '/greetings'}>Greetings</button></li>
// <li><button className="side-button" onClick={() => window.location.href = '/profile'}> Verified Profile</button></li>
// <li><button className="side-button" onClick={handleLogout}>LogOut</button></li>
//                 </ul>
//             </div>

//             <div className="profile-content">
//                 <h1>Profile Details</h1>

//                 {userData ? (
//                     <div className="profile-info">
//                         <ul>
//                             <li><strong>Name:</strong> {userData.name}</li>
//                             <li><strong>Email:</strong> {userData.email}</li>

//                             <li><strong>District:</strong> {userData.district}</li>
//                             {/* Add other fields as needed */}
//                         </ul>
//                     </div>
//                 ) : (
//                     <p>Loading profile data...</p>
//                 )}
//             </div>
//         </>
//     );
// }

// export default Profile;


import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import './Profile.css'; // Assuming you have a Profile.css for styling
import axios from "axios";
import { Col, Container,Button, Pagination, Row, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const Profile = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const data = sessionStorage.getItem('userData');
        if (data) {
            setUserData(JSON.parse(data)); // Parse the stored JSON string
        }
    }, []);
    
console.log(userData)
    const handleLogout = () => {
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('adminEmail');
        sessionStorage.removeItem('userDistrict');
        navigate('/');
    };


    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch data from the Express API
    // useEffect(() => {
    //     axios
    //         .get('https://lionsnewsapi.emedha.in/superAdmin/userData')
    //         .then((response) => {
    //             setData(response.data);
    //             setLoading(false);
    //         })
    //         .catch((error) => {
    //             setError('An error occurred while fetching data');
    //             setLoading(false);
    //         });
    // }, []);

    
    // useEffect(() => {
    //     // Check if userData is available before accessing its district property
    //     if (userData && userData.district) {
    //         axios
    //             .get('https://lionsnewsapi.emedha.in/superAdmin/userData')
    //             .then((response) => {
    //                 // Get district from userData
    //                 const userDistrict = userData.district;
    
    //                 // Filter the response data based on district match
    //                 const filteredData = response.data.filter((item) => item.district === userDistrict);
    
    //                 // Set the filtered data to state
    //                 setData(filteredData);
    //                 setLoading(false);
    //             })
    //             .catch((error) => {
    //                 setError('An error occurred while fetching data');
    //                 setLoading(false);
    //             });
    //     } else {
            
    //         setLoading(false); 
    //     }
    // }, [userData]); 
    
    const fetchData = async () => {
        if (userData && userData.district) {
            try {
                const response = await axios.get('https://lionsnewsapi.emedha.in/superAdmin/userData');
                const userDistrict = userData.district;

                // Filter the response data based on district match
                const filteredData = response.data.filter((item) => item.district === userDistrict);

                // Set the filtered data to state
                setData(filteredData);
                setLoading(false);
            } catch (error) {
                setError('An error occurred while fetching data');
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };


        // Call fetchData whenever userData changes
        useEffect(() => {
            fetchData();
        }, [userData]);
    console.log(data)

    const itemsPerPage = 10;

    // State to manage the current page
    const [currentPage, setCurrentPage] = useState(1);

    // Calculate the total number of pages
    const totalPages = Math.ceil(data.length / itemsPerPage);

    // Function to handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Get the data for the current page
    const currentData = data.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const [users, setUsers] = useState([]);

    const handleStatusChange = (userId, status) => {
        axios
            .post('https://lionsnewsapi.emedha.in/api/otp/updateStatus', { userId, status })
            .then((response) => {
                alert(response.data.message);  // Alert or update the UI accordingly
                setUsers((prevUsers) => 
                    prevUsers.map((user) =>
                        user.id === userId ? { ...user, status } : user
                    )
                );
                fetchData();
            })
            .catch((error) => {
                console.error('Error updating status:', error);
            });
    };

    return (
        <>
            <div className="sidebar-nav">
                <h2>Menu</h2>
                <ul>
                    {/* <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboard'}>Posts</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboardGreetings'}>Greetings</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminAdminUsers'}>Admin's</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminUsers'}>Users's</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboardProfile'}>Profile</button></li>
                    <li><button className="side-button" onClick={handleLogout}>LogOut</button></li> */}
                    <li><button className="side-button" onClick={() => window.location.href = '/Dashboard'}>Posts</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/greetings'}>Greetings</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/profile'}> Verified Profile</button></li>
                    <li><button className="side-button" onClick={handleLogout}>LogOut</button></li>
                </ul>
            </div>

            <div className="profile-content">
                {/* <Container className="mt-4">
                    <Row>
                        <Col>
                            <h1 className="mb-4">Users Details</h1>
                            <div>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Profile Pic</th>
                                            <th>Username</th>
                                           
                                            <th>Mobile</th>
                                            <th>Email</th>
                                            <th>District</th>
                                            <th>Club</th>
                                            <th>Membership No</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                <td>
                                                    <img
                                                        src={item.profilePic}
                                                        alt="Profile"
                                                        className="img-fluid"
                                                        style={{ maxWidth: '100px', maxHeight: '100px' }}
                                                    />
                                                </td>
                                                <td>{item.username}</td>
                                                <td>{item.mobile}</td>
                                                <td>{item.email}</td>
                                                <td>{item.district}</td>
                                                <td>{item.club}</td>
                                                <td>{item.membershipNo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <Pagination>
                                    <Pagination.Prev
                                        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                                    />
                                    {[...Array(totalPages)].map((_, index) => (
                                        <Pagination.Item
                                            key={index + 1}
                                            active={index + 1 === currentPage}
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </Pagination.Item>
                                    ))}
                                    <Pagination.Next
                                        onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                                    />
                                </Pagination>
                                <span>
                                    Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container> */}

<Container className="mt-4">
            <Row>
                <Col>
                    <h1 className="mb-4">Users Details</h1>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Profile Pic</th>
                                <th>Username</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>District</th>
                                <th>Club</th>
                                <th>Membership No</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((item, index) => (
                                <tr key={index}>
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>
                                        <img
                                            src={item.profilePic}
                                            alt="Profile"
                                            className="img-fluid"
                                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                                        />
                                    </td>
                                    <td>{item.username}</td>
                                    <td>{item.mobile}</td>
                                    <td>{item.email}</td>
                                    <td>{item.district}</td>
                                    <td>{item.club}</td>
                                    <td>{item.membershipNo}</td>
                                    <td>
                                                {item.status === 'approved' || item.status === 'rejected' ? (
                                                    <Button variant={item.status === 'approved' ? 'success' : 'danger'} disabled>
                                                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Button
                                                            variant="success"
                                                            onClick={() => handleStatusChange(item.id, 'approved')}
                                                            disabled={item.status === 'rejected'}
                                                        >
                                                            Approve
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            onClick={() => handleStatusChange(item.id, 'rejected')}
                                                            disabled={item.status === 'approved'}
                                                        >
                                                            Reject
                                                        </Button>
                                                    </>
                                                )}
                                            </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {/* Pagination */}
                    <Pagination>
                        <Pagination.Prev
                            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                        />
                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                        />
                    </Pagination>
                    <span>
                        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </span>
                </Col>
            </Row>
        </Container>
            </div>
        </>
    );
}

export default Profile;
